module.exports = __webpack_public_path__ + "img/icon2.ed6973e9.svg";